import React, { useState, useEffect } from 'react'
import { Flex } from '../../../Components/Common/Flex'
import { DataTable } from 'primereact/datatable'
import { Checkbox } from 'primereact/checkbox'
import { Column } from 'primereact/column'
import { columnProps } from '../../../Services/Functions'
import { Button } from '../../../Components/Common/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { useCInfiniteQuery } from '../../../Services/QueryCache'
import { Text } from '../../../Components/Common/Text'
import { deleteForm } from './Functions'
import { Modal } from '../../../Components/Common/Modal'

export const FormWebList = () => {
  const { environmentId } = useParams()
  const [onlyToCompile, setOnlyToCompile] = useState(true)
  const { data: formsWeb = [], isSuccess } = useCInfiniteQuery(['formsWeb', environmentId, onlyToCompile])
  const [modalVisible, setModalVisible] = useState(false)
  const [idToDelete, setIdToDelete] = useState('')
  const [formsWebDisplay, setFormsWebDisplay] = useState(formsWeb)

  useEffect(() => {
    if (isSuccess) {
      setFormsWebDisplay(formsWeb.map(item => ({
        ...item.data || {},
        ...item
      })))
    }
  }, [formsWeb?.length, isSuccess])

  const navigate = useNavigate()

  const BtnActionProc = ({ id }) => (
    <Flex row style={{ width: '100%' }}>
      <Button round tooltip='Visualizza' icon='fa-duotone fa-pen' style={{ marginRight: 10 }} onClick={() => navigate('/environments/' + environmentId + '/webForm/' + id)} />
      <Modal visible={modalVisible} header='Cancellazione documento' onHide={() => setModalVisible(false)}>
        <Flex fw>
          <Text value='Vuoi cancellare questo documento?' />
          <Flex fw row jb style={{ marginTop: 20 }}>
            <Button label='Annulla' icon='fa-duotone fa-trash' onClick={() => setModalVisible(false)} />
            <Button
              label='Conferma' icon='fa-duotone fa-check' onClick={() => {
                deleteForm(idToDelete)
                setModalVisible(false)
              }}
            />
          </Flex>
        </Flex>
      </Modal>
      <Button round tooltip='Elimina' icon='fa-duotone fa-trash' onClick={() => { setIdToDelete(id); setModalVisible(true) }} />
    </Flex>
  )

  return (
    <Flex fw>
      <Flex fw jb row>
        <div style={{ width: '20%' }} />
        <Text value='Elenco Form Web' size={22} bold />
        <Flex row je style={{ width: '20%' }}>
          <Text value='Solo form ancora da compilare' style={{ marginRight: 10 }} />
          <Checkbox
            checked={onlyToCompile} onChange={e => setOnlyToCompile(e.checked)}
          />
        </Flex>
      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' className='TableSignatures' sortField='startDate' sortOrder={1}
        value={formsWebDisplay} emptyMessage='Nessuna form caricato' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='ragioneHotel' {...columnProps('Hotel')} />
        <Column field='partitaIvaHotel' {...columnProps('IVA Hotel')} />
        <Column field='dataInVouEng' {...columnProps('Data Check-in')} />
        <Column field='dataOutVouEng' {...columnProps('Data Check-out')} />
        <Column field='paxVou' {...columnProps('Pax')} />
        <Column field='createdAt' {...columnProps('Data')} body={(row) => new Date(row.createdAt).toLocaleString()} style={{ width: 200 }} />
        <Column style={{ border: 'none', width: 220, height: 15, textAlign: 'center' }} body={(props) => <BtnActionProc {...props} />} />
      </DataTable>
    </Flex>
  )
}
